<template>
    <div class="tab-pane fade" id="OrderTransport" role="tabpanel" aria-labelledby="ordertransport-tab">
        <div class="h3 mb-3 text-white">Bestillingstransport</div>
        <div class="form-group">
            <a href="https://www.vkt.no/reise/vkt-bestilling/" class="btn btn-primary" title="Gå til bestilling" aria-label="Gå til bestilling">Gå til bestilling</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'OrderTransport'
    }
</script>